// thing:no-export
let NEXT_ID = 0;
export const nextID = () => NEXT_ID++;
